import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import ErrorMessage from './ErrorMessage';
import { TERMS_STATE, PAGES } from '../lib/constants';

window.dataLayer = window.dataLayer || [];
let analyticsPushed;

const TermsOfUseAcceptance = (props) => {
  const state = props.termsState;
  let component = null;

  const pushSignupAnalytics = () => {
    var e = { event: 'signup', step: '2', step_name: 't&c' };
    window.dataLayer.push(e);
  }

  switch(state) {
    case TERMS_STATE.HIDE:
      break;
    case TERMS_STATE.SHOW_MODAL:
      component = <Modal { ...props } />;
      if (props.page === PAGES.SIGNUP && !analyticsPushed) {
        pushSignupAnalytics();
        analyticsPushed = true;
      };
      break;
    case TERMS_STATE.SHOW_ERROR:
      component = <ErrorMessage { ...props } />;
      break;
    default:
      break;
  }

  return (
    <div>
      { component }
    </div>
  );
};

TermsOfUseAcceptance.propTypes = {
  termsState: PropTypes.string.isRequired,
};

export default TermsOfUseAcceptance;
